/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { JewelDiamondIcon16Light } from './JewelDiamondIcon16Light';
import { JewelDiamondIcon16Regular } from './JewelDiamondIcon16Regular';
import { JewelDiamondIcon16Solid } from './JewelDiamondIcon16Solid';
import { JewelDiamondIcon20Light } from './JewelDiamondIcon20Light';
import { JewelDiamondIcon20Regular } from './JewelDiamondIcon20Regular';
import { JewelDiamondIcon20Solid } from './JewelDiamondIcon20Solid';
import { JewelDiamondIcon24Regular } from './JewelDiamondIcon24Regular';
import { JewelDiamondIcon24Solid } from './JewelDiamondIcon24Solid';
import { JewelDiamondIcon32Regular } from './JewelDiamondIcon32Regular';
import { JewelDiamondIcon64Regular } from './JewelDiamondIcon64Regular';
var sizes = {
    16: {
        light: JewelDiamondIcon16Light,
        regular: JewelDiamondIcon16Regular,
        solid: JewelDiamondIcon16Solid,
    },
    20: {
        light: JewelDiamondIcon20Light,
        regular: JewelDiamondIcon20Regular,
        solid: JewelDiamondIcon20Solid,
    },
    24: {
        regular: JewelDiamondIcon24Regular,
        solid: JewelDiamondIcon24Solid,
    },
    32: {
        regular: JewelDiamondIcon32Regular,
    },
    64: {
        regular: JewelDiamondIcon64Regular,
    },
};
export var JewelDiamondIcon = forwardRef('JewelDiamondIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
